// START Open Requre.JS wrapper
define([
    'jquery',
    "wcs.context",
	'shared.main.screen',
    "pubsub"
    ], function ( $, ctx, screenSize ){

// END Open Require.JS wrapper

/****
 * Product Form Online Dealers
 ***/

    var PLUGIN_IDENTIFIER = 'OnlineDealers';

	var OnlineDealers = function ( element ) {

		this.$element 		 		 = $(element);
		this.$productForm 			 = this.$element.closest('.product-form-js');
		this.onlineDealerURL 		 = ctx.getURLWithContextRoot( $(this.$element).first().data('bfd-url') );
		this._viableOnlineDealer	 = [];
		this.onlineDealerFirstLoad	 = true;
		this._cachedOnlineDealerList = this._cachedOnlineDealerList || 0;
		this._onlineDealerProductIds = [];

		this.storeId 	= ctx.getStoreId();
		this.langId 	= ctx.getLangId();
		this.productId  = this.$element.closest('.product-form-js').find('input[name=catEntryId]').val();

	};

	OnlineDealers.prototype = {

		init : function () {

			var self = this;

			console.log('Initializing Online Dealers');

			self.initOnlineDealer();
			self.initOnlineDealerEvents();

			return self;

		},

		initOnlineDealer : function () {

			var self = this;

			//this will prevent multiple ajax calls
			if( self.onlineDealerFirstLoad && self.onlineDealerURL ){
				// fire AJAX request to fetch the online dealer data
				$.ajax({
					type: 'GET',
					url: self.onlineDealerURL,
					data: {
						storeId: self.storeId,
						langId: self.langId,
						productId: self.productId
					},
					dataType: 'JSON'
				}).done(function(data){
					self.handleOnlineDealerResponse(data);
				});
			}

		},

		initOnlineDealerEvents : function() {

			var self = this;

			$.pubsub('subscribe', 'WCS.PDPSWATCHES.PRODUCTFORM.EVENT.FORMCLICK', function(){
				self.handleOnlineDealersSection();
			});

			$.pubsub('subscribe', 'window.resize', function(){
				self.populateOnlineDealers();
			});

			$.pubsub('subscribe', 'WCS.PRODUCTFORM.EVENT.ONLINEDEALER.ACTIVE', function(){
				self.displayOnlineDealers();
			});

		},

		handleOnlineDealerResponse : function(data){

			var self = this;

			self.onlineDealerFirstLoad   = false;
			self._cachedOnlineDealerList = data;

			self._cachedOnlineDealerList.map(function(value, index){

				Object.keys(value.products).forEach(function(value){

					self._onlineDealerProductIds.push(value);
				});

			});

			self.$element.each(function(){

				var $this 	 = $(this),
					$content = $('.dealer-info-template-js', $this);

				self._cachedOnlineDealerList.map( function(value, item){

					var $newContent = $content.clone().hide();

					$newContent.attr('id', self._cachedOnlineDealerList[item].id);
					$newContent.find('.dealer-logo-js').attr('data-src', self._cachedOnlineDealerList[item].logo);
					$newContent.find('.dealer-name-js').text(self._cachedOnlineDealerList[item].name);

					$newContent.appendTo($this);
				});

			});

		},

		displayOnlineDealers : function () {

			var self = this;

			$('.notify-me-container-js').removeClass('expanded');

			self.$element.each(function(){

				var $this = $(this);

				if($this.hasClass('expanded')){

					$this.slideUp(500);
					$this.removeClass('expanded');

				}else{

					self.populateOnlineDealers();

					$('img.lazy', $this).lazyload();

					$this.slideDown(500, function() {
						self.scrollToSection($this);
					});

					$this.addClass('expanded');

				}

			});

		},

		scrollToSection : function (scrollSection) {

			$('html, body').animate({

				scrollTop: scrollSection.offset().top

			}, 500);

		},

		populateOnlineDealers : function () {

			var self = this;

			self.$element.each(function(){

				var $this = $(this),
					windowWidth = $(window).width(),
					index = 1,
					$content = $('.dealer-info-template-js', $this),
					columnNum = $this.data('column-'+screenSize.size());

				//remove pre-existing first/ last / middle classes & hide online dealer
				$content.removeClass('first');
				$content.removeClass('last');
				$content.hide();

				self._viableOnlineDealer.map(function(value, item){

					var $onlineDealer = $('#'+ self._viableOnlineDealer[item], $this),
						columnIndex;

					//show online dealer
					$onlineDealer.show();

					//add appropriate first / last / middle class
					columnIndex = index++ % columnNum;

					if(columnIndex === 0){

						$onlineDealer.addClass('last');

					}else if (columnIndex == 1 ){

						$onlineDealer.addClass('first');

					}

				});

			});
		},

		getOnlineDealers : function ( productId ) {

			var self = this,
				isViableDealer = false;

			self._viableOnlineDealer = [];

      		if ( !self._cachedOnlineDealerList ) { return; }

			Object.keys(self._cachedOnlineDealerList).forEach(function(index){

				var productList 	= self._cachedOnlineDealerList[index].products,
					dealerProductId = self._cachedOnlineDealerList[index].id;

				if (productList[productId]) {
					isViableDealer = true;
					/*set the ppr_url for the dealer*/
					product = productList[productId];
					$('#'+dealerProductId).attr("href",product.url);
				}

				//if isViableDealer is true, add id into viableOnlineDealer array
				if(isViableDealer){
					self._viableOnlineDealer.push(dealerProductId);
					isViableDealer = false;
				}
			});

			return self._viableOnlineDealer;

		},

		getProductColorCode: function(data, selectedColor, selectedSize){

			var self = this,
				colorAttrId = $('.product-attr-form .attr-color').attr('data-attribute-id') || null,
				sizeAttrId  = $('.product-attr-form .attr-size').attr('data-attribute-id') || null,
				productCode;

			//if product does not have color, use size options
			if(colorAttrId === null){
				productCode = data.attributes[sizeAttrId][selectedSize];
			} else {
				productCode =  data.attributes[colorAttrId][selectedColor];
			}

			if ( typeof productCode !== 'undefined' ){
				productCode.map(function(ob, i) {
					if (self._onlineDealerProductIds.indexOf(ob) > -1) {
						$('.attr-size .attr-box:eq('+[i]+')', self.$productForm).removeClass('out-of-stock');
					}
				});
			}

		},

		handleOnlineDealersSection : function () {
			var self = this;
			if($('.online-dealer-js').hasClass('expanded')){
				self.displayOnlineDealers();
				$('.online-dealer-js').removeClass('expanded').slideUp();
			}
		}

	};

	// prevent duplicate instantiation
	$.fn.OnlineDealers = function() {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new OnlineDealers( this ).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};

// START close Require.JS wrapper
});
// END close Require.JS wrapper
